"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeMultiSelectDropdownContent = void 0;
const react_1 = __importDefault(require("react"));
const Row_1 = require("./Row");
require("./index.scss");
const className = 'badge-multi-select-dropdown-content';
const BadgeMultiSelectDropdownContent = (props) => {
    const { value = [], setValue, items, toItem, } = props;
    const mappedValue = value.map(toItem);
    return (react_1.default.createElement("div", { className: className }, items === null || items === void 0 ? void 0 : items.map(item => {
        const mappedItem = toItem(item);
        const itemProps = {
            title: mappedItem.name,
            isSelected: !!mappedValue.find(x => x.value === mappedItem.value),
            onClick: () => {
                if (mappedValue.find(x => x.value === mappedItem.value))
                    return;
                const newValue = [...value, item];
                setValue === null || setValue === void 0 ? void 0 : setValue(newValue);
            },
            onClose: () => {
                if (!mappedValue.find(x => x.value === mappedItem.value))
                    return;
                const newValue = value.filter(x => toItem(x).value !== mappedItem.value);
                setValue === null || setValue === void 0 ? void 0 : setValue(newValue);
            },
        };
        return (react_1.default.createElement(Row_1.BadgeMultiSelectDropdownContentRow, { key: mappedItem.value, ...itemProps }));
    })));
};
exports.BadgeMultiSelectDropdownContent = BadgeMultiSelectDropdownContent;
//# sourceMappingURL=index.js.map